function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BusinessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import TblDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import TblDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import InformMassiveUpload from '@/components/InformMassiveUpload.vue';
import { bulkLoadMixin } from '@/mixins/bulk_load';
import tasks from "@/js/tasks";
import { mapState } from 'vuex';
import { GA_EVENTS, BIGQUERY_TYPES, FOH_DOMAINS, isFOHDomain } from '@/js/constants';
var bulkTable = 'table';
var bulkDatasource = 'datasource';
var bulkDashboard = 'dashboard';
var bulkBusiness = 'business';
var bulkTemplates = {};
var bulkDummy = {};
var bulkSchemas = {};
bulkTemplates[bulkTable] = 'org;domain;subdomain;official_source;proyecto;dataset;Table;description;operator;public;env;zone;area;bus_data_steward;data_owner;tech_data_steward;table_load_logic;tables_relationship;final_table;Table1;Column;data_element_name;business_definition;transformation_logic;sensitive;type;length;valid_values;primary_key;null;encrypted;column_load_logic';
bulkDummy[bulkTable] = "\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;config_id;ok;ok;lineal;N;STRING;10;Null;N;N;N;Null\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;element_id;ok;ok;lineal;N;STRING;10;Null;Y;N;N;Null\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;element_value;ok;ok;lineal;N;STRING;10;Null;N;N;N;Null\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;rule_id;ok;ok;lineal;N;STRING;10;Null;N;N;N;Null\n";
bulkSchemas[bulkTable] = {
  org: {
    type: 'string',
    default: '',
    required: true
  },
  domain: {
    type: 'string',
    default: '',
    required: true
  },
  subdomain: {
    type: 'string',
    default: '',
    required: true
  },
  official_source: {
    type: 'string',
    default: '',
    required: true
  },
  proyecto: {
    type: 'string',
    default: '',
    required: true
  },
  dataset: {
    type: 'string',
    default: '',
    required: true
  },
  Table: {
    type: 'string',
    default: '',
    required: true
  },
  description: {
    type: 'string',
    default: '',
    required: false
  },
  operator: {
    type: 'string',
    default: '',
    required: true
  },
  public: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  env: {
    type: 'string',
    default: 'prod',
    required: true,
    valid_values: ['dev', 'prod']
  },
  zone: {
    type: 'string',
    default: 'OTHER',
    required: true
  },
  area: {
    type: 'string',
    default: 'general',
    required: true
  },
  upload_platform: {
    type: 'string',
    default: '',
    required: false
  },
  upload_process: {
    type: 'string',
    default: '',
    required: false
  },
  final_table: {
    type: 'string',
    default: 'Y',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  Table1: {
    type: 'string',
    default: '',
    required: false
  },
  Column: {
    type: 'string',
    default: '',
    required: true
  },
  data_element_name: {
    type: 'string',
    default: '',
    required: false
  },
  business_definition: {
    type: 'string',
    default: '',
    required: false
  },
  transformation_logic: {
    type: 'string',
    default: '',
    required: false
  },
  sensitive: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  type: {
    type: 'string',
    default: 'STRING',
    required: false
  },
  length: {
    type: 'string',
    default: '0',
    required: false
  },
  valid_values: {
    type: 'string',
    default: '',
    required: false
  },
  primary_key: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  null: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  encrypted: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  }
};
bulkTemplates[bulkDatasource] = 'organization;object_name;domain;subdomain;data_operator;environment;path_name;sensitive_data;object_description;field_name;business_definition;masked;sensitive_data';
bulkDummy[bulkDatasource] = "\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;AREA;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;CAPITAL;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;CODCCPP;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;DEPARTAMEN;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;DISTRITO;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;FUENTE;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;Geometry;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;IDDIST;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;IDDPTO;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;IDPROV;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;PROVINCIA;;false;false\n";
bulkTemplates[bulkDashboard] = 'organization;object_name;domain;subdomain;data_operator;environment;path_name;sensitive_data;object_description';
bulkDummy[bulkDashboard] = "\nINTERCORP;Analitica Digital v2;CLIENTES;CLIENTES;gyupanqui@intercorp.com.pe;dev;Data Office;false;carga masiva\n";
bulkTemplates[bulkBusiness] = 'business_term;definition;domain;subdomain;status;critical;values;classification;accountable;also_known_as;contains;has_a_type;is_a_related_term_from;is_a_type_of;is_calculated_from;is_contained_in;is_used_to_calculate;related_term';
bulkDummy[bulkBusiness] = "\nHASH ID;ID utilizado en Google Analytics;OPERACIONES;SISTEMAS Y PROCESOS;true;false;hash, id;id, identificador;gyupanqui@intercorp.com.pe;user id\n";
bulkSchemas[bulkBusiness] = {
  business_term: {
    type: 'string',
    default: '',
    required: true
  },
  definition: {
    type: 'string',
    default: '',
    required: false
  },
  domain: {
    type: 'string',
    default: '',
    required: true
  },
  subdomain: {
    type: 'string',
    default: '',
    required: true
  },
  status: {
    type: 'boolean',
    default: false,
    required: false
  },
  critical: {
    type: 'boolean',
    default: false,
    required: false
  },
  values: {
    type: 'string',
    default: '',
    required: false
  },
  classification: {
    type: 'string',
    default: '',
    required: false
  },
  accountable: {
    type: 'string',
    default: '',
    required: false
  },
  also_known_as: {
    type: 'string',
    default: '',
    required: false
  },
  contains: {
    type: 'string',
    default: '',
    required: false
  },
  has_a_type: {
    type: 'string',
    default: '',
    required: false
  },
  is_a_related_term_from: {
    type: 'string',
    default: '',
    required: false
  },
  is_a_type_of: {
    type: 'string',
    default: '',
    required: false
  },
  is_calculated_from: {
    type: 'string',
    default: '',
    required: false
  },
  is_contained_in: {
    type: 'string',
    default: '',
    required: false
  },
  is_used_to_calculate: {
    type: 'string',
    default: '',
    required: false
  },
  related_term: {
    type: 'string',
    default: '',
    required: false
  }
};
export default {
  name: 'BusinessGlossaryLoadBulk',
  components: {
    InformMassiveUpload: InformMassiveUpload
  },
  mixins: [bulkLoadMixin],
  data: function data() {
    return {
      csvFile: null,
      error_message: false,
      message: '',
      messageServer: '',
      colorAlert: '',
      TYPE_ERROR: 'error',
      TYPE_WARNING: 'warning',
      TYPE_SUCCESS: 'success',
      showMessageServer: false,
      MODAL_INFORM_BULK: 'ModalBulkUpload',
      tplToInform: [],
      isLoading: false,
      bulkType: 'business',
      dialogFlag: false,
      bulkStep: 1,
      tableauRecords: [],
      tableauErrors: [],
      bulkStepError: false,
      isHovering: false,
      MESSAGE_WARNING_UPLOAD: 'Uploaded with some observations',
      MESSAGE_ERROR_UPLOAD: 'La carga no pudo completarse debido a errores en la metadata.\nConsulta los detalles para más información.',
      list_source: [{
        value: 'bigquery',
        text: "Bigquery"
      }, {
        value: 'synapse',
        text: "Azure Synapse"
      }],
      source: 'bigquery'
    };
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName', 'isSynapseActive', 'organizations'])), {}, {
    bulkOptions: function bulkOptions() {
      return [{
        value: bulkBusiness,
        text: this.traductor('my_tasks.bterms')
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_tasks.subtitle_bulk_load'),
        disabled: true
      }];
    },
    load_csv: function load_csv() {
      return this.traductor('my_tasks.upload_csv');
    },
    texts: function texts() {
      return {
        bulk_load: this.traductor('frases.bulk_load')
      };
    }
  }),
  methods: {
    showBulkSimpleErrors: function showBulkSimpleErrors(data) {
      var errors = new Set();
      data.forEach(function (item) {
        (item.columns || []).forEach(function (col) {
          if (!col.success && col.message) {
            errors.add(col.message.trim());
          }
        });
      });
      if (!errors.size) return;
      var msg = Array.from(errors).join('\n') + '\n\nRevise su archivo CSV.';
      tasks.toast.error(msg);
    },
    // --- helpers para saber qué columna validar y cómo ---
    requiredDescField: function requiredDescField(bulkType) {
      // nombre del campo “descripción” según el tipo seleccionado en Paso 1
      if (bulkType === 'table') return 'description';
      if (bulkType === 'datasource' || bulkType === 'dashboard') return 'object_description';
      return null; // business no exige descripción
    },
    isInvalidText: function isInvalidText(val) {
      console.log("isInvalidText val: ".concat(val));
      var v = (val || '').trim().toLowerCase();
      return !v || /^null$/i.test(v); // vacío, espacios o "null"/"NULL"...
    },
    isInvalidEmail: function isInvalidEmail(val) {
      var v = (val || '').trim();
      console.log("isInvalidEmail val: ".concat(val));

      // Validación básica de formato de email
      if (!v || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        return true;
      }

      // Validación de dominio específico para FOH/IFXP
      if (isFOHDomain(window.userInfo.domain)) {
        var emailDomain = v.split('@')[1];
        return !FOH_DOMAINS.includes(emailDomain);
      }
      return false;
    },
    isInvalidBigqueryTypes: function isInvalidBigqueryTypes(val) {
      var valid_types = BIGQUERY_TYPES;
      return !valid_types.includes((val || '').toUpperCase());
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    validateFile: function validateFile(file) {
      if (!file) {
        this.error_message = true;
        this.message = 'You must choose a file at least';
        return false;
      } else if (/\.csv$/i.test(file.name)) {
        // <-- acepta .csv o .CSV
        this.error_message = false;
        return true;
      } else {
        this.error_message = true;
        this.message = 'This is not CSV file!';
        return false;
      }
    },
    parseRow: function parseRow(row) {
      var row_trimed = row && row.trim();
      if (row_trimed === 'false' || row_trimed === 'N') return false;
      if (row_trimed === 'true' || row_trimed === 'Y') return true;
      if (!row_trimed || row_trimed === '') return false;
      if (row_trimed && row_trimed.includes(',')) return row_trimed.split(',');
      return row_trimed;
    },
    onBack: function onBack() {
      this.isHovering = false;
      this.bulkStep--;
      this.bulkStepError = false;
      this.csvFile = null;
    },
    // ===================== TABLAS =====================
    uploadTableFile: function uploadTableFile() {
      var _this = this;
      var reader = new FileReader();
      reader.readAsText(this.csvFile, 'ISO-8859-1');
      reader.onload = function (e) {
        var header = bulkTemplates['table'].split(';');
        var body = _this.getBodyJson(e);
        var records = [];
        var _iterator = _createForOfIteratorHelper(body),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var body_item = _step.value;
            var record = {};
            for (var index in header) {
              var property = header[index].trim();
              var row = body_item[property];
              if (bulkTemplates['table'].includes(property)) {
                record[property] = row ? row.trim() : '';
              }
            }

            // === validación específica: description obligatorio y no "Null"
            var descField = _this.requiredDescField('table'); // "description"
            console.log("descField: ".concat(descField));
            console.log(_this.organizations, '-> this.organizations');
            // if(this.organizations.includes(record['org']) === false){
            //   record['org'] = this.organizations[0];
            //   tasks.toast.warning(`org no es válida. Se asignará la organización por defecto '${this.organizations[0]}'. Verifique su archivo CSV.`);

            // }

            if (_this.isInvalidText(record['proyecto'])) {
              tasks.toast.error("proyecto es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
              return;
            }
            if (_this.isInvalidText(record['dataset'])) {
              tasks.toast.error("dataset es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
              return;
            }
            if (_this.isInvalidText(record['Table'])) {
              tasks.toast.error("Table es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
              return;
            }

            /*Solo para prod*/
            if (record['env'].toLowerCase() === 'prod') {
              if (_this.isInvalidText(record['official_source'])) {
                tasks.toast.error("official_source es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this.isInvalidText(record['business_definition'])) {
                tasks.toast.error("business_definition es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this.isInvalidText(record['zone'])) {
                tasks.toast.error("zone es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
            }

            /*Solo para FINANCIERA OH!**/
            if (isFOHDomain(window.userInfo.domain)) {
              // record['org'].toUpperCase() ==='FINANCIERA OH!' ){
              console.log(record, '-> table_load_logic');
              var domainMsg = " El dominio debe ser uno de: ".concat(FOH_DOMAINS.join(', '), ".");
              if (_this.isInvalidEmail(record['operator'])) {
                tasks.toast.error("operator debe ser un correo electr\xF3nico v\xE1lido. Verifique su archivo CSV. ".concat(domainMsg));
                return;
              }
              console.log("data_owner", record['data_owner']);
              console.log(_this.isInvalidText(record['data_owner']), 'isInvalidText');
              if (_this.isInvalidText(record['data_owner']) && _this.isInvalidEmail(record['data_owner'])) {
                tasks.toast.error("data_owner debe ser un correo electr\xF3nico v\xE1lido. Verifique su archivo CSV. ".concat(domainMsg));
                return;
              }
              if (_this.isInvalidText(record['bus_data_steward']) && _this.isInvalidEmail(record['bus_data_steward'])) {
                tasks.toast.error("bus_data_steward debe ser un correo electr\xF3nico v\xE1lido. Verifique su archivo CSV. ".concat(domainMsg));
                return;
              }
              if (_this.isInvalidText(record['tech_data_custodiam']) && _this.isInvalidEmail(record['tech_data_custodiam'])) {
                tasks.toast.error("tech_data_custodiam debe ser un correo electr\xF3nico v\xE1lido. Verifique su archivo CSV. ".concat(domainMsg));
                return;
              }
              if (_this.isInvalidText(record['zone'])) {
                tasks.toast.error("zone es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this.isInvalidText(record['description'])) {
                tasks.toast.error("description es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this.isInvalidText(record['business_definition'])) {
                tasks.toast.error("business_definition es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
            }
            var typesFormatted = BIGQUERY_TYPES.join(', ');
            if (_this.isInvalidBigqueryTypes(record['type'])) {
              tasks.toast.error("El campo \"type\" debe ser un tipo v\xE1lido de BigQuery.\n\nTipos permitidos:\n".concat(typesFormatted, "\n\n . Verifique su archivo CSV."));
              return;
            }
            if (_this.isInvalidText(record['area']) && record['area'].toUpperCase() !== 'GENERAL') {
              tasks.toast.error("El area ingresada no es correcta. Por defecto es \"general\".");
              return;
            }
            var errors = false;
            var schema = bulkSchemas['table'];
            for (var _property in schema) {
              var value = record[_property];
              var fieldSchema = schema[_property];
              if (fieldSchema.required && !value) {
                errors = true;
                tasks.toast.error("".concat(_property, " is required, check your csv file."));
                break;
              } else if (!fieldSchema.required && !value) {
                record[_property] = fieldSchema.default;
                value = fieldSchema.default;
              } else if (_typeof(value) !== fieldSchema.type) {
                errors = true;
                tasks.toast.error("".concat(_property, " requires ").concat(fieldSchema.type, ", check your csv file."));
                break;
              }
              if (fieldSchema.valid_values && value) {
                if (!fieldSchema.valid_values.includes(value)) {
                  errors = true;
                  tasks.toast.error("Only these values are allowed for ".concat(_property, ": ").concat(fieldSchema.valid_values, "."));
                  break;
                } else {
                  switch (_property) {
                    case 'public':
                    case 'sensitive':
                    case 'primary_key':
                    case 'null':
                    case 'encrypted':
                    case 'final_table':
                      record[_property] = _this.parseRow(value);
                      break;
                    default:
                      record[_property] = value;
                  }
                }
              }
            }
            if (errors) return;
            records.push(record);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.isLoading = true;
        var params = {
          records: records,
          source: _this.source
        };
        TablesService.bulkLoad(params).then(function (response) {
          _this.showMessageServer = true;
          _this.isLoading = false;
          if (response.success) {
            _this.tplToInform = response.data || [];
            var records_uploaded = 0;
            var errors = [];
            response.data.forEach(function (item) {
              var columns = item.columns || [];
              columns.forEach(function (column) {
                records_uploaded += 1;
                if (!column.success) errors.push(column);
              });
            });
            console.log("records_uploaded: ".concat(records_uploaded, ", errors: ").concat(errors.length));
            if (errors.length > 0) {
              //this.openDetails();
              _this.showBulkSimpleErrors(response.data);
              _this.colorAlert = _this.TYPE_ERROR;
              _this.messageServer = _this.MESSAGE_ERROR_UPLOAD;
              _this.bulkStepError = true;
            } else {
              _this.bulkStep++;
              _this.colorAlert = _this.TYPE_SUCCESS;
              _this.messageServer = "Uploaded successfully!";
              if (_this.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'table',
                  company_code: _this.companyCode,
                  hash_email: _this.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            }
          } else if (!response.success || response.code >= 500) {
            _this.bulkStep++;
            _this.colorAlert = _this.TYPE_ERROR;
            _this.messageServer = _this.MESSAGE_ERROR_UPLOAD;
            _this.bulkStepError = true;
          }
          _this.csvFile = null;
        }).catch(function (e) {
          console.log(e);
          _this.isLoading = false;
        });
      };
    },
    // ================= DATASOURCE / DASHBOARD =================
    uploadTableauFile: function uploadTableauFile() {
      var _this2 = this;
      var self = this;
      var reader = new FileReader();
      reader.readAsText(this.csvFile);
      reader.onload = function (e) {
        var results = e.target.result.split('\n');
        var header = e.target.result.split('\n')[0];
        var separators = [',', ';', '|'];
        var separator = '';
        for (var _i = 0, _separators = separators; _i < _separators.length; _i++) {
          separator = _separators[_i];
          if (header.indexOf(separator) !== -1) break;
        }
        header = header.split(separator);
        var header_general = ['organization', 'object_name', 'domain', 'subdomain', 'data_operator', 'environment', 'database_engine', 'path_name', 'object_owner', 'sensitive_data', 'object_description'];
        var header_columns = ['business_definition', 'field_name', 'formula', 'masked', 'sensitive_data'];
        var body = [];
        var records = [];
        for (var index in results.filter(function (r) {
          return r;
        })) {
          if (index) {
            body.push(results[index].split(separator));
          }
        }
        var record = {};
        var bodyVisited = [];
        var column = {};
        var skipHeader = true;
        var rowKey = '';
        for (var _i2 = 0, _body = body; _i2 < _body.length; _i2++) {
          var body_item = _body[_i2];
          if (skipHeader) {
            skipHeader = false;
            continue;
          }
          record = {};
          if (_this2.bulkType === 'datasource') {
            record['columns'] = [];
          }
          for (var header_index in header) {
            if (header_general.includes(header[header_index] && header[header_index].trim())) {
              record[header[header_index].trim()] = self.parseRow(body_item[header_index]);
            }
          }
          if (!record.path_name || !record.object_name) {
            tasks.toast.error("path_name and object_name are required, check your csv file");
            return;
          }
          rowKey = "".concat(record.path_name, "_").concat(record.object_name);
          if (!bodyVisited.includes(rowKey)) {
            skipHeader = true;
            var _iterator2 = _createForOfIteratorHelper(body),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var body_item_j = _step2.value;
                if (skipHeader) {
                  skipHeader = false;
                  continue;
                }
                if (_this2.bulkType === 'datasource') {
                  column = {};
                  for (var column_index in header) {
                    if (header_columns.includes(header[column_index] && header[column_index].trim())) {
                      column[header[column_index].trim()] = self.parseRow(body_item_j[column_index]);
                    }
                  }
                  if (!column.field_name) {
                    tasks.toast.error("field_name is required, check your csv file");
                    return;
                  }
                  record['columns'].push(column);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            records.push(record);
          }
          bodyVisited.push(rowKey);
        }
        var args = {
          domain: window.userInfo.domain,
          records: records
        };
        _this2.isLoading = true;
        if (_this2.bulkType === 'datasource') {
          TblDatasourceService.bulkLoad(args).then(function (response) {
            _this2.bulkStep++;
            _this2.showMessageServer = true;
            _this2.isLoading = false;
            if (response.success) {
              _this2.tableauRecords = response.data;
              _this2.colorAlert = _this2.TYPE_SUCCESS;
              _this2.messageServer = "[".concat(response.data.length, "] record(s) uploaded successfully !");
              if (_this2.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'tbl_datasource',
                  company_code: _this2.companyCode,
                  hash_email: _this2.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            } else {
              _this2.colorAlert = _this2.TYPE_ERROR;
              _this2.messageServer = _this2.MESSAGE_ERROR_UPLOAD;
              _this2.bulkStepError = true;
            }
          });
        } else {
          TblDashboardService.bulkLoad(args).then(function (response) {
            _this2.bulkStep++;
            _this2.showMessageServer = true;
            _this2.isLoading = false;
            if (response.success) {
              _this2.tableauRecords = response.data;
              _this2.colorAlert = _this2.TYPE_SUCCESS;
              _this2.messageServer = "[".concat(response.data.length, "] record(s) uploaded successfully !");
              if (_this2.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'tbl_dashboard',
                  company_code: _this2.companyCode,
                  hash_email: _this2.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            } else {
              _this2.colorAlert = _this2.TYPE_ERROR;
              _this2.messageServer = _this2.MESSAGE_ERROR_UPLOAD;
              _this2.bulkStepError = true;
            }
          });
        }
      };
    },
    uploadBusinessTerm: function uploadBusinessTerm() {
      var _this3 = this;
      var self = this;
      var reader = new FileReader();
      reader.readAsText(this.csvFile);
      reader.onload = function (e) {
        var header = bulkTemplates[bulkBusiness].split(';');
        var body = _this3.getBody(e);
        var records = [];
        var _iterator3 = _createForOfIteratorHelper(body),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var body_item = _step3.value;
            var record = {
              'relationship': {}
            };
            for (var header_index in header) {
              var property = header[header_index].trim();
              var row = body_item[header_index];
              if (bulkTemplates[bulkBusiness].includes(property)) {
                switch (property) {
                  case 'definition':
                    record[property] = row.trim();
                    break;
                  case 'values':
                  case 'classification':
                  case 'contains':
                  case 'has_a_type':
                  case 'is_a_related_term_from':
                  case 'is_a_type_of':
                  case 'is_calculated_from':
                  case 'is_contained_in':
                  case 'is_used_to_calculate':
                  case 'related_term':
                    console.log("row for ".concat(property, ": ").concat(row));
                    record[property] = row ? row.split(',').map(function (v) {
                      return v.trim();
                    }).filter(function (v) {
                      return v !== '';
                    }) : [];
                    break;
                  default:
                    //record[property] = self.parseRow(row)
                    var fieldSchema = bulkSchemas[bulkBusiness][property];
                    if (fieldSchema && fieldSchema.type === 'string') {
                      record[property] = (row || '').trim(); // siempre string
                    } else {
                      record[property] = self.parseRow(row); // boolean para status/critical
                    }
                    break;
                }
              }
            }
            var errors = false;
            var businessTermSchema = bulkSchemas[bulkBusiness];
            for (var _property2 in businessTermSchema) {
              var value = record[_property2];
              var _fieldSchema = businessTermSchema[_property2];
              if (_fieldSchema.required && !value) {
                errors = true;
                tasks.toast.error("".concat(_property2, " is required, check your csv file."));
                // alert(`${property} is required, check your csv file.`)
                break;
              } else if (_typeof(value) !== _fieldSchema.type) {
                if (!Array.isArray(value)) {
                  errors = true;
                  tasks.toast.error("".concat(_property2, " for ").concat(record.business_term, " requires ").concat(_fieldSchema.type, ", check your csv file."));
                  // alert(`${property} for ${record.business_term} requires ${fieldSchema.type}, check your csv file.`)
                  break;
                }
              }
            }
            if (errors) {
              return;
            }
            records.push(record);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var args = {
          records: records
        };
        BusinessTermService.bulkLoad(args).then(function (response) {
          _this3.bulkStep++;
          _this3.showMessageServer = true;
          _this3.isLoading = false;
          _this3.tableauRecords = [];
          _this3.tableauErrors = [];
          if (response.success) {
            _this3.tableauRecords = response.data;
            for (var index in _this3.tableauRecords) {
              var record = _this3.tableauRecords[index];
              console.log("record: ".concat(record));
              if (!record.success) {
                _this3.tableauErrors.push(record);
              }
            }
            if (_this3.tableauErrors.length === _this3.tableauRecords.length) {
              // Todos los términos a subir tuvieron errores
              _this3.colorAlert = _this3.TYPE_ERROR;
              _this3.messageServer = _this3.MESSAGE_ERROR_UPLOAD;
              _this3.bulkStepError = true;
            } else if (_this3.tableauErrors.length > 0) {
              // 1 o más términos tuvieron errores
              _this3.colorAlert = _this3.TYPE_WARNING;
              _this3.messageServer = _this3.MESSAGE_WARNING_UPLOAD;
              if (_this3.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'bterm',
                  company_code: _this3.companyCode,
                  hash_email: _this3.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            } else {
              // Todos los términos se subieron correctamente
              _this3.colorAlert = _this3.TYPE_SUCCESS;
              _this3.messageServer = "[".concat(response.data.length, "] record(s) uploaded successfully !");
              if (_this3.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'bterm',
                  company_code: _this3.companyCode,
                  hash_email: _this3.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            }
          } else if (!response.success || response.code >= 500) {
            _this3.colorAlert = _this3.TYPE_ERROR;
            _this3.messageServer = _this3.MESSAGE_ERROR_UPLOAD;
            _this3.bulkStepError = true;
          }
        });
      };
    },
    onSubmit: function onSubmit(event) {
      /*
       * Se anula el comportamiento por defecto del submit
       * que es recargar la página 13/04/20
       */
      event.preventDefault();
      var condicion = this.validateFile(this.csvFile);
      this.tableauRecords = [];
      this.tplToInform = [];
      console.log('[bulkType]', this.bulkType);
      if (condicion) {
        if (this.bulkType === bulkTable) {
          this.uploadTableFile();
        } else if ([bulkDatasource, bulkDashboard].includes(this.bulkType)) {
          this.uploadTableauFile();
        } else if (this.bulkType === bulkBusiness) {
          this.uploadBusinessTerm();
        }
      }
    },
    openDetails: function openDetails() {
      this.$refs.dialog.onOpen();
      // this.$bvModal.show(this.MODAL_INFORM_BULK)
    },
    downloadTemplate: function downloadTemplate() {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var template = "".concat(bulkTemplates[this.bulkType]).concat(bulkDummy[this.bulkType]);
      var encode = encodeURIComponent("".concat(universalBOM).concat(template));
      var url = "data:text/csv; charset=utf-8,".concat(encode);
      a.href = url;
      a.download = "template_".concat(this.bulkType, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
};